export default import.meta.ROLLDOWN_FILE_URL_AdFzoO30pW$n9GHudK3dCg